<template>
    <div v-if="site" class="v-flex" style="width: calc(100% + 10px)">
        <d-image-folder-create
            v-model  = "showCreate"
            :site    = "site"
            @created = "onFolderCreated"
        />
        <input
            ref      = "fileInput"
            type     = "file"
            multiple
            :accept  = "accept"
            style    = "display: none"
            @change  = "onFilesPicked"
        />
        <div v-if="loading" class="img-loading">
            <v-progress-circular indeterminate color="primary" size="48" />
        </div>
        <div
            style="width: 500px; margin-left: calc(50% - 250px); margin-top: 90px"
            v-if="folders && folders.length === 0"
        >
            <v-card>
                <v-card-text>{{ $t('img.folder.create.empty') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="showCreate = true">
                        {{ $t('img.folder.create.action') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>

        <div class="w-100 v-flex h-100" v-if="folders && folders.length > 0">
            <div class="d-flex flex-column align-self-start" style="width: 400px; min-width: 300px;">
            <v-tabs
                :key    = "tabsKey"
                show-arrows
                v-model = "folderIndex"
                class   = "ma-0 pa-0 mt-2 folder-tabs"
                @change = "onFolder"
                vertical
                style="width: 100%;"
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                    v-for        = "(folder,index)  in folders"
                    :key         = "index"
                    active-class = "folder-tab-active primary"
                    class        = "folder-tab"
                >
                    <div class="folder-tab-content">
                        <div v-if="!folder.date">
                            <div class="folder-date">
                                {{ $t( 'image.category.common' )}}
                            </div>
                            <div class="folder-name">
                                {{ folderLabel (folder) }}
                            </div>
                        </div>
                        <div v-if="folder.date">
                            <div class="folder-date">
                                {{ formatDate (folder.date) }}
                            </div>
                            <div class="folder-name">
                                {{ folderLabel (folder) }}
                            </div>
                        </div>
                        <div class="folder-count">{{ folder.images }}</div>
                    </div>
                </v-tab>
            </v-tabs>
            <div class="mt-2">
                <v-btn text small color="primary" @click="showCreate = true">
                    <v-icon left small>mdi-folder-plus</v-icon>
                    {{ $t('img.folder.create.action') }}
                </v-btn>
            </div>
            </div>
            <v-container
                class="img-panel mt-2"
                @dragenter.prevent = "onDragEnter"
                @dragover.prevent
                @dragleave.prevent = "onDragLeave"
                @drop.prevent      = "onDrop"
            >
                <div class="drop-overlay" v-if="dragging">
                    <v-icon x-large color="primary">mdi-upload</v-icon>
                    <div>{{ $t('img.upload.drop') }}</div>
                </div>
                <div style="height: 740px; overflow-y: scroll; padding-right: 1px; width: 100%;" v-if="folder" :key="refresh" >
                    <img-lightbox
                        v-if      = "carousel"
                        :images   = "sortedImages"
                        :position.sync = "position"
                        @close    = "onClose"
                    />

                    <div class="folder-actions">
                        <v-btn text small color="primary" @click="$refs.fileInput.click()">
                            <v-icon left small>mdi-upload</v-icon>
                            {{ $t('img.upload.action') }}
                        </v-btn>
                        <v-btn
                            text small color="primary"
                            :loading  = "downloading"
                            :disabled = "!images || images.length === 0"
                            @click    = "onDownloadFolder"
                        >
                            <v-icon left small>mdi-download</v-icon>
                            {{ $t('img.download.action') }}
                        </v-btn>
                        <span class="folder-empty" v-if="images && images.length === 0">
                            {{ $t('img.folder.create.noimages') }}
                        </span>
                        <v-spacer />
                        <span class="folder-sort-label">{{ $t('img.sort.label') }}</span>
                        <v-select
                            v-model       = "sort"
                            :items        = "sortItems"
                            dense
                            hide-details
                            class         = "folder-sort"
                        />
                    </div>

                    <v-row style=" margin-left: -2px; margin-top: -2px;">
                        <v-col
                            v-for="(image, index) in sortedImages"
                            :key="image.id"
                            class="d-flex child-flex image-col"
                            :cols="cols"
                        >
                            <div>
                                <a @click="onSelect(index)">
                                    <img-image :id="image.id" :item="image" />
                                </a>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>

import Img from "@/modules/img/components/service/Img";
import { DEFAULT_SORT, SORTS, sortImages } from "@/modules/img/components/service/ImageSort";
import ImgImage from "@/modules/img/components/main/ImgImage";
import ImgLightbox from "@/modules/img/components/main/ImgLightbox";
import Core from "@/modules/core/service/Core";
import FolderDownload from "@/modules/img/components/service/FolderDownload";
import DImageFolderCreate from "@/modules/img/components/DImageFolderCreate.vue";
import Uploads from "@/modules/img/components/service/Uploads";
import { ACCEPT } from "@/modules/img/components/service/UploadQueue";

export default {
    name: "ImgSiteImages",

    components: {
        DImageFolderCreate,
        ImgImage,
        ImgLightbox,
    },

    props: {
        site: {

        }
    },

    data: () => ({
        folder: null,
        images: null,
        sort: DEFAULT_SORT,
        refresh: 0,
        carousel: false,
        position: 0,
        folders: null,
        folderIndex: 0,
        downloading: false,
        loading: true,
        showCreate: false,
        accept: ACCEPT,
        dragging: false,
        dragDepth: 0,
        stopWatching: null,
        reloadTimer: null,
        tabsKey: 0,
    }),

    watch: {
        unitId () {
            this.loadFolders(this.site.id);
        }
    },

    mounted() {
        this.loadFolders(this.site.id);
        // show what the media service has processed while the upload goes on
        this.stopWatching = Uploads.onFileDone(({ siteId, folderId }) => {
            if (this.folder && siteId === this.site.id && folderId === this.folder.id) {
                this.reloadSoon();
            }
        });
    },

    beforeDestroy () {
        if (this.stopWatching) {
            this.stopWatching();
        }
        clearTimeout(this.reloadTimer);
    },

    computed: {
        unitId () {
            if (!this.site) {
                return null;
            }

            return this.site.id;
        },

        sortedImages () {
            return sortImages(this.images, this.sort);
        },

        sortItems () {
            return SORTS.map(value => ({ value, text: this.$t("img.sort." + value) }));
        },

        cols () {
            const preferences = this.$store.getters.preferences;
            return preferences.smallimages ? 1 : 2;
        }
    },

    methods: {
        onFolder () {
            this.carousel = false;
            this.folder = this.folders[this.folderIndex];
            this.loadImages();
        },

        onSelect (index) {
            this.carousel = true
            this.position = index;
        },

        // Select the new folder
        onFolderCreated (created) {
            this.showCreate = false;

            // Show it right away from the answer of the create request, the list follows. (The list request
            // can wait behind running uploads and thumbnails: browsers send only a few requests at once.)
            const folders = (this.folders || []).slice();
            if (!folders.some(folder => folder.id === created.id)) {
                folders.push(created);
            }
            this.selectFolders(folders, created.id);

            Img.load(this.site.id).then(data => {
                // the user may have switched to another folder meanwhile
                const selected = this.folder ? this.folder.id : created.id;
                this.selectFolders(data.folders, selected);
            });
        },

        /** Takes [folders] and selects the folder with [id]; the tabs are rebuilt only if the list changed. */
        selectFolders (folders, id) {
            const same = this.folders && this.folders.length === folders.length
                && this.folders.every((folder, index) => folder.id === folders[index].id);
            const index = Math.max(folders.findIndex(folder => folder.id === id), 0);
            const changed = !same || !this.folder || this.folder.id !== folders[index].id;

            this.folders = folders;
            this.folderIndex = index;
            if (changed) {
                this.folder = folders[index];
                // rebuild the tabs, they don't pick up a changed list reliably
                this.tabsKey++;
                this.loadImages();
            }
        },

        onDownloadFolder () {
            const folder = this.folder;
            const name = this.folderLabel(folder);
            this.downloading = true;
            FolderDownload.zip(this.sortedImages).then(url => {
                if (url) {
                    FolderDownload.save(url, (this.site.fabricNo || this.site.id) + " " + name + ".zip");
                    Core.message.hint(this, this.$t("img.download.done"));
                }
            }).catch(() => {
                Core.message.hint(this, this.$t("img.download.failed"));
            }).finally(() => {
                this.downloading = false;
            });
        },

        onFilesPicked (event) {
            this.upload(Array.from(event.target.files));
            event.target.value = "";
        },

        upload (files) {
            if (!this.folder || files.length === 0) {
                return;
            }
            Uploads.add({
                siteId     : this.site.id,
                folderId   : this.folder.id,
                siteLabel  : String(this.site.fabricNo || this.site.id),
                folderLabel: this.folderLabel(this.folder),
            }, files);
        },

        isFileDrag (event) {
            return !!this.folder && Array.from(event.dataTransfer.types || []).includes("Files");
        },

        onDragEnter (event) {
            if (this.isFileDrag(event)) {
                this.dragDepth++;
                this.dragging = true;
            }
        },

        onDragLeave () {
            this.dragDepth = Math.max(this.dragDepth - 1, 0);
            this.dragging = this.dragDepth > 0;
        },

        onDrop (event) {
            const isFiles = this.isFileDrag(event);
            this.dragDepth = 0;
            this.dragging = false;
            if (isFiles) {
                this.upload(Array.from(event.dataTransfer.files));
            }
        },

        // at most one reload every 2 seconds, however many files finish
        reloadSoon () {
            if (this.reloadTimer) {
                return;
            }
            this.reloadTimer = setTimeout(() => {
                this.reloadTimer = null;
                this.loadImages(true);
            }, 2000);
        },

        onClose () {
            this.carousel = false;
        },

        loadFolders (siteId) {
            this.loading = true;
            Img.load(siteId).then((data) => {
                this.folders = data.folders;
                    if (this.folders && this.folders.length > 0) {
                    this.folder = this.folders[0];
                    this.loadImages()
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        // [keepView]: don't rebuild the gallery, so the scroll position stays
        loadImages (keepView) {
            const folder = this.folder;
            return Img.images(this.site.id, folder)
                .then(data => {
                    if (folder !== this.folder) {
                        return;
                    }
                    this.images = data;
                    // the list of folders was loaded earlier: keep its count current
                    this.$set(folder, "images", data.length);
                    if (keepView !== true) {
                        this.refresh++;
                    }
                })
                .catch(() => {
                    if (keepView !== true) {
                        this.images = [];
                        this.refresh++;
                    }
                })

        },

        folderLabel (folder) {
            // categories like "image.cat.site" are translated, names users gave a folder are not
            const name = this.$te(folder.name) ? this.$t(folder.name) : folder.name;
            return name;
        },

        formatDate (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

.img-loading {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
}

.drop-overlay {
    /* like .image-overlay: sits where it is in the flow, over the gallery */
    position: absolute;
    height: 740px;
    width: calc(100% - 70px);
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed var(--v-primary-base);
    background-color: rgba(255, 255, 255, 0.85);
    pointer-events: none;
}

.img-panel {
    display: flex;
    padding: 0;
    min-width: calc(100% - 300px);
}

.image-col {
    padding: 2px;
}

.folder-tab {
    text-transform: unset;
    letter-spacing: unset;
    font-size: 15px;
    color: black!important;
    font-weight: normal;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-right: 5px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    width: calc(100% - 5px);
    margin-bottom: 2px;
    height: 44px!important;
}

.folder-tabs {
    /* as high as the folders, so the button for a new folder follows right after the last one */
    flex: 0 0 auto;
    height: auto;
    padding-right: 75px;
    margin-bottom: 4px;
    border-bottom-style: none;
    border-bottom-width: 1px;
    margin-right: 75px;
    border-bottom-color: lightgray;
    width: calc(100% - 10px);
}

.folder-actions {
    display: flex;
    align-items: center;
    padding: 2px 0 6px;
}

.folder-sort-label {
    margin-right: 8px;
    font-size: 14px;
    color: gray;
    white-space: nowrap;
}

.folder-sort {
    flex: 0 0 170px;
    max-width: 170px;
    margin: 0 12px 0 0;
    padding-top: 0;
}

.folder-empty {
    margin-left: 12px;
    font-size: 14px;
    color: gray;
}

.folder-date {

}

.folder-name {
    font-size: 12px;
    margin-top: 2px;
}

.folder-tab-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left;
}

.folder-count {
    margin-left: 12px;
    font-size: 12px;
    opacity: 0.7;
}

.folder-tab-active {
    color: white!important;
}

::v-deep .theme--light.v-tabs>.v-tabs-bar {
    border-bottom-style: none!important;
}

div::-webkit-scrollbar {
    width: 8px !important;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3)!important;
    border-radius: 8px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 8px;
}

::v-deep .v-tabs-slider {
    display: none;
}

</style>
